export default __webpack_public_path__ + "static/media/Snd_CO.cf47d0e2.mp3";